module.exports = __webpack_public_path__ + "img/logo.6bc194e4.png";